( function () {
   
    'use strict';

    ( function ( $ ) {
       
        $('.partner-slider').slick({
            dots:false,
            infinite: true,
            speed: 600,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay:true,
            autoplaySpeed: 2000,
            arrows:false,
            responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow:4,
                }
            },
            {
                breakpoint:768,
                settings: {
                    slidesToShow:1,
                    centerMode: true,
                    centerPadding: '80px',
                }
            }
            ]
        });
    } )(jQuery);
} )();

